import React from "react";
import useCurrentTime from "../CustomHooks/useCurrentTime";
import Typography from '@mui/material/Typography';

const Header = ({ activeClient }) => {
  const date = useCurrentTime();
  const [siteNames, setSiteNames] = React.useState(null);
  const [clientName, setClientName] = React.useState(null);

  React.useEffect(() => {
    activeClient && clientSitesHandler();
  }, [activeClient]);

  const clientSitesHandler = () => {
    const sites = activeClient.sites.reduce((accumulator, site) => {
      accumulator.push(site.name);
      return accumulator;
    }, []);

    setSiteNames(sites.join(" / "));
    setClientName(activeClient.client.name);
  };

  return (
    <>
      <Typography
        variant="h5"
        style={{
          color: "#0077C8",
          fontWeight: 600,
        }}
      >
        {clientName}
      </Typography>
      <Typography
        variant="h4"
        style={{
          fontWeight: 300,
          fontSize: 20,
        }}
      >
        {siteNames}
      </Typography>
      <Typography
        variant="h4"
        style={{
          fontWeight: 300,
          fontSize: 20,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {date.date}
        <Typography
          style={{
            fontWeight: 700,
            fontSize: 26,
            marginLeft: 5,
            lineHeight: 1.167,
            letterSpacing: "0em",
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          }}
        >
          {date.hours}:{date.minutes < 10 ? 0 : null}
          {date.minutes}
        </Typography>
        :{date.seconds < 10 ? 0 : null}
        {date.seconds}{" "}
      </Typography>
    </>
  );
};

export default Header;
